// extracted by mini-css-extract-plugin
export var billingAddress = "_rg-f";
export var contactInfo = "_rg-c";
export var customerInfoContainer = "_rg-b";
export var customerInfoRow = "_rg-9";
export var customerInfoSection = "_rg-a";
export var fullWidthDividerMobile = "_rg-g";
export var imageContainer = "_rg-1";
export var paymentMethod = "_rg-d";
export var priceText = "_rg-6";
export var priceTextMobile = "_rg-7";
export var product = "_rg-0";
export var productImage = "_rg-2";
export var productInfo = "_rg-4";
export var productTitle = "_rg-8";
export var quantityBadge = "_rg-3";
export var quantityText = "_rg-5";
export var shippingAddress = "_rg-e";